import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Avatar } from './Avatar';

export const FollowingSidebar = () => {
  const navigate = useNavigate();
  const [following, setFollowing] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFollowing();
  }, []);

  const fetchFollowing = async () => {
    try {
      const response = await axios.get('/users/following');
      setFollowing(response.data);
    } catch (error) {
      console.error('Failed to fetch following:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserClick = (username) => {
    navigate(`/user/${username}`);
  };

  if (loading) {
    return null;
  }

  if (following.length === 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 0.1 }}
      className="bg-white rounded-lg shadow-sm p-5 border border-cardBorder"
    >
      <div className="flex items-center gap-2 mb-4">
        <Users className="w-4 h-4 text-grayMeta" />
        <h3 className="font-baloo font-bold text-base text-primaryDark">Following</h3>
      </div>
      <div className="space-y-3">
        {following.slice(0, 5).map((user) => (
          <div 
            key={user.id} 
            onClick={() => handleUserClick(user.username)}
            className="flex items-center gap-2 cursor-pointer hover:bg-surface p-2 -mx-2 rounded-lg transition-colors"
          >
            <Avatar username={user.username} size="sm" />
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-xs text-primaryDark truncate hover:text-primary-dark transition-colors">
                @{user.username}
              </div>
            </div>
          </div>
        ))}
        {following.length > 5 && (
          <div className="text-xs text-grayMeta text-center pt-2 border-t border-cardBorder">
            +{following.length - 5} more
          </div>
        )}
      </div>
    </motion.div>
  );
};
